module.exports = __webpack_public_path__ + "img/lifull_homes_white.4da4b7c0.svg";